const firebaseConfig = {
  apiKey: "AIzaSyAuTVRoeWYWI1LTESe7OoZVoCCVL1o5M7w",
  authDomain: "programming-book-store.firebaseapp.com",
  projectId: "programming-book-store",
  storageBucket: "programming-book-store.appspot.com",
  messagingSenderId: "416057881385",
  appId: "1:416057881385:web:8744e46805a118c6843d38"
};
export default firebaseConfig;